/**
 * Tools for SVG Root Element.
 * @module svgcanvas
 * @license MIT
 *
 * @copyright 2010 Alexis Deveria, 2010 Jeff Schiller
 */
import { NS } from '../common/namespaces';
import { text2xml } from './utilities';

/**
* @function module:svgcanvas.svgRootElement svgRootElement the svg node and its children.
* @param {Document} svgdoc - window.document
* @param {[Float, Float]} dimensions - dimensions of width and height
* @returns {svgRootElement}
*/
export const svgRootElement = function (svgdoc: Document, dimensions: [Float, Float]) {
    return svgdoc.importNode<SVGSVGElement>(
        text2xml(
            `<svg id="svgroot" xmlns="${NS.SVG}" xlinkns="${NS.XLINK}" width="${dimensions[0]}" 
            height="${dimensions[1]}" x="${dimensions[0]}" y="${dimensions[1]}" overflow="visible">
            <defs>
              <filter id="canvashadow" filterUnits="objectBoundingBox">
                <feGaussianBlur in="SourceAlpha" stdDeviation="4" result="blur"/>
                <feOffset in="blur" dx="5" dy="5" result="offsetBlur"/>
                <feMerge>
                  <feMergeNode in="offsetBlur"/>
                  <feMergeNode in="SourceGraphic"/>
                </feMerge>
              </filter>
              <filter id="knockout-preview">
                <feBlend in="SourceGraphic" in2="BackgroundImage" mode="normal" />
              </filter>
            </defs>
          </svg>`
        ).documentElement as unknown as SVGSVGElement,
        true
    );
};
